<template>
     <div>
        <div class="pay-items">
          <div class="row row-wrap">
            <div class="col col-4" :class="key" v-for="(item, key) in providers" :key="key">
              <div class="item" v-if="item.is_active" v-show="(_.isNull(filter) || (!_.isNull(filter) && item.name.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) >= 0))">
                <div class="image">
                  <img :src="$store.state.main.cdn_url + '/providers/' +  key  + '.png?v=1.2'" height="20">
                </div>
                <h3>{{ $t('payment.services.' + key) }}</h3>
                <div class="bottom">
                    <span>Minimum: {{ item.min_pay }} ₺</span>
                    <span v-if="!isMobile"> - </span>
                    <span>Maksimum: {{ item.max_pay }} ₺</span>
                </div>
                <div class="button primary" @click="go(key)"> 
                  <strong v-if="type == 'deposit'">Para Yatır</strong>
                  <strong v-else>Para Çek</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
     </div>
</template>

<script>
  export default{
    props:['providers', 'go', 'type','filter'],
    computed:{
      client_id(){
        return process.env.VUE_APP_CLIENT_ID
      },
    },
  }
</script>